import { makeStyles, shorthands } from '@fluentui/react-components';

export const useSummaryResultDialogStyles = makeStyles({
  summaryMessage: {
    paddingBottom: '16px',
  },
  summaryListContainer: {
    maxHeight: '300px',
    overflowY: 'auto',
    paddingBottom: '12px',
  },
  dialog: {
    '&.fui-DialogSurface': {
      maxWidth: '778px',
      overflowY: 'hidden',
      overflowX: 'auto',
      '& .fui-DialogContent': {
        maxWidth: '724px',
      },
      '& .fui-DialogActions': {
        width: '724px',
        ...shorthands.borderTop('1px', 'solid', '#F1F1F1'),
        paddingTop: '16px',
      },
    },
  },
  grid: {
    '&.fui-DataGrid': {
      width: 'fit-content',
    },
  },
  gridCell: {
    '&.fui-DataGridCell': {
      paddingTop: '6px',
      paddingBottom: '6px',
      '& div': {
        ...shorthands.overflow('hidden'),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
      },
    },
  },
  gridHeaderCell: {
    '&.fui-DataGridHeaderCell .name': {
      fontWeight: 600,
    },
  },
});

export const useImagePreviewStyles = makeStyles({
  imagePreviewContainer: {
    width: '92px',
    height: '60px',
  },
});

export const useValueWithTooltipViewStyles = makeStyles({
  overflow: {
    display: 'block',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  overflowLeft: {
    display: 'block',
    ...shorthands.overflow('hidden'),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left',
    direction: 'rtl',
  },
  customToolTip: {
    ...shorthands.padding('0px 10px 10px 10px'),
  },
  toolTipContentHeader: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
  },
  toolTipContent: {
    marginTop: '10px',
  },
});

export const useAssociationsButtonStyles = makeStyles({
  associationsButton: {
    '&.fui-Button': {
      ...shorthands.border('none'),
      fontWeight: 'normal',
      '&:hover': {
        color: '#0078d4',
      },
    },
  },
});
